import React from 'react';
import {connect} from 'react-redux';
import {houseStore} from '../../../../../redux/entities/inventory/house';
import {CommonState} from '../../../../../redux';
import {bindActionCreators, Dispatch} from 'redux';
import {EntityManagementModal} from '../../../../../components/util/EntityManagementModal/EntityManagementModal';

interface Props {
  opened: boolean;
  onClose: () => void;
}

type ConnectedProps = Props & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const HouseModal: React.FC<ConnectedProps> = ({opened, onClose, unarchivedHouses, archivedHouses, actions}) => {
  return (
    <EntityManagementModal
      opened={opened}
      onClose={onClose}
      title="Manage Houses"
      entityName="House"
      unarchivedEntities={unarchivedHouses}
      archivedEntities={archivedHouses}
      actions={actions}
    />
  );
};

const mapStateToProps = (state: CommonState) => ({
  unarchivedHouses: houseStore.selectors.unarchived(state),
  archivedHouses: houseStore.selectors.archived(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({
    upsert: houseStore.actions.upsert,
    archive: houseStore.actions.archive,
    restore: houseStore.actions.restore
  }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(HouseModal);
